module.exports = __webpack_public_path__ + "img/copy.0d9d0462.svg";